import { BaseCurrencyEquivalentCalculation } from '@/common/types/enums';
import { Attachment } from '@/library/types/files';

export enum SurveyDifferenceApplicableType {
  None = 'none',
  Departure = 'departure_report',
  PortNoon = 'port_noon_or_departure_report'
}

export enum BudgetRemainingCalculationType {
  ordered = 'ordered',
  invoiced_delivered_ordered = 'invoiced_delivered_ordered'
}

export type CompanySettingListItem = { key: string; label: string };

export type CompanySettings = {
  'sync_onboard.crew_documents.chunk_size'?: string;
  'sync_onboard.crew_documents.delete_limit_per_case'?: string;
  system_currency?: string;
  crew_member_username?: string;
  crew_member_password?: string;
  deactivate_vessel_access_days_after_sign_off?: string;
  crew_ticketing_cases_show_pdf_export?: number;
  crew_member_external_id_keys?: CompanySettingListItem[];
  crew_wage_group_automation_from?: string;
  crew_wage_group_automation_to?: string;
  evaluations_range_from?: string;
  evaluations_range_to?: string;
  evaluations_step?: string;
  external_email_type?: string;
  external_email_status?: string;
  purchasing_email_status?: string;
  'elastic.form_submissions'?: number;
  itinerary_edit_scheduled_ports_onboard?: string;
  mga_inventory_depletion_method?: string;
  mga_disable_warnings_on_reviewed_period?: string;
  pms_overdue_jobs_percentage_limit?: string;
  spare_parts_inventory_survey_interval?: string;
  spare_parts_inventory_survey_interval_unit?: string;
  running_hours_report_interval_days?: string;
  pms_jobs_require_total_system_running_hours_when_reported_in_the_system?: string;
  pms_assign_system_and_subsystem_or_assignment_to_group?: string;
  pms_vessel_system_assignment_description_pattern?: string;
  pms_first_job_status_properties?: { progress: string; edit_side: string };
  purchasing_requisitions_highlight_most_expensive?: string;
  purchasing_requisition_code?: string;
  purchasing_requisitions_highlight_cheapest?: string;
  purchasing_pdf_show_company_notes?: number;
  purchasing_pdf_show_invoices_should_be_sent_to?: number;
  purchasing_pdf_show_invoices_should_be_issued_to?: number;
  purchasing_requisition_prefill_po_company?: number;
  apply_the_lubricant_survey_difference_as_correction_to?: SurveyDifferenceApplicableType;
  apply_the_bunker_survey_difference_as_correction_to?: SurveyDifferenceApplicableType;
  logo?: string;
  'logo-text'?: string;
  form_export_header_logo?: number[] | Attachment | null;
  form_export_header_show_linked_manual?: number;
  'form-show-header'?: number;
  allow_invoice_linking_only_with_cases_of_same_or_connected_company?: number;
  reverse_accounting_journal_entries?: number;
  invoices_prefill_allocation_date_with?: string;
  invoices_ocr_engine?: string;
  base_currency_equivalent_calculation?: BaseCurrencyEquivalentCalculation;
};
